/**
 * Allowed attachment MIME types for ticket conversations.
 * Keep in sync with upload middleware and client-side validation.
 */
export const ALLOWED_ATTACHMENT_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

export type AllowedAttachmentMimeType = (typeof ALLOWED_ATTACHMENT_MIME_TYPES)[number];

export const ALLOWED_ATTACHMENT_EXTENSIONS_LABEL = 'JPEG, PNG, PDF, DOC, DOCX';

export function isAllowedAttachmentMimeType(mimeType: string): boolean {
  return (ALLOWED_ATTACHMENT_MIME_TYPES as readonly string[]).includes(mimeType);
}

export const MAX_ATTACHMENT_BATCH_BYTES = 10 * 1024 * 1024;

export const MAX_ATTACHMENT_BATCH_MB = MAX_ATTACHMENT_BATCH_BYTES / (1024 * 1024);

export function validateAttachmentBatch(
  files: ReadonlyArray<{ size: number }>,
): string | null {
  if (files.length === 0) return null;
  const total = files.reduce((sum, file) => sum + file.size, 0);
  if (total > MAX_ATTACHMENT_BATCH_BYTES) {
    return `Total attachment size must be ${MAX_ATTACHMENT_BATCH_MB} MB or less`;
  }
  return null;
}
